import http from "../http-common";
/* eslint-disable */
class HubungiKamiService {
  getHubungiKami() {
    return http.get("/hubungi-kami", {
      headers: {
        "Content-type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  update(data, id) {
    var bodyFormData = new FormData();
    bodyFormData.append("deskripsi", data.deskripsi);
    bodyFormData.append("deskripsi_en", data.deskripsi_en);

    if (id) bodyFormData.append("id", id);

    return http.post(`/hubungi-kami`, bodyFormData, {
      headers: {
        "Content-type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }
}

export default new HubungiKamiService();
